export const AdminTypes = {
  IGetUserAccessesService: Symbol("IGetUserAccessesService"),
};
